import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const connectionsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/connections',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: { label: 'Connections', isCurrentPage: true },
        },
    ],
};
